import { CommandType } from "~app/common/services/cqs/CommandType";
import { ProduktionsmallHandelssortimentBaseCommand } from "./ProduktionsmallHandelssortimentBaseCommand";

export class AddProduktionsmallHandelssortimentCommand extends ProduktionsmallHandelssortimentBaseCommand {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "AddProduktionsmallHandelssortimentCommand";

    constructor(produktionsmallGuid: string, handelssortimentId: number) {
        super(AddProduktionsmallHandelssortimentCommand.$type, CommandType.Insert);
        this.produktionsmallGuid = produktionsmallGuid;
        this.handelssortimentId = handelssortimentId;
    }
}
